import { useTimeout } from "@tracking/hooks";
import PropTypes from "prop-types";
import { useState } from "react";

function FuseLoading(props) {
  const [showLoading, setShowLoading] = useState(!props.delay);

  useTimeout(() => {
    setShowLoading(true);
  }, props.delay);

  return (
    <div className={"flex flex-1 flex-col items-center justify-center p-24"}>
      Loading...
    </div>
  );
}

FuseLoading.propTypes = {
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

FuseLoading.defaultProps = {
  delay: false,
};

export default FuseLoading;
